// extracted by mini-css-extract-plugin
export default {"templates-iframe-wrapper":"styles_templates-iframe-wrapper__-mq3K"};